import { Component, OnInit, Input } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ChecklistValidacionComponent } from '../../pages/seguimiento/checklist-validacion/checklist-validacion.component';
import { Utilerias } from 'src/app/helpers/Utilerias';
import { MasterDB } from 'src/app/DAO/MasterDB';
import { EstacionesTVADB } from 'src/app/DAO/EstacionesTVADB';
import { RubroTranRubro, ValidaRubroDTO } from 'src/app/types/type';
import { RubroService } from 'src/app/services/rubro.service';
declare var $: any;

@Component({
  selector: 'app-rubro',
  templateUrl: './rubro.component.html',
  styleUrls: ['./rubro.component.css']
})
export class RubroComponent implements OnInit {
  @Input() rubro;
  @Input() global;
  userSesion: any;
  defaultColor: string = 'black';
  disableValidaRubro = false;

  constructor(private rubroService: RubroService, private http: HttpClient, private parent: ChecklistValidacionComponent) {
  }

  ngOnInit() {
    this.userSesion = this.global.userSesion;
    this.global.idRubro = this.rubro.IdRubro;
    this.rubro.Estatus = this.global.CatEstatusRubro.find(x => x.IdEstatusRubro == this.rubro.IdEstatus);
  }

  isShowAcciones() {
    return this.parent.revision.IdEtapa == 4;
  }

  isShowObservaciones() {
    return this.parent.revision.IdEtapa == 3 || this.parent.revision.IdEtapa == 4;
  }

  isCumpleRubro(calificacion) {
    return this.parent.isCumpleRubro(calificacion);
  }

  async clickValidarRubro(idRubro: number) {
    this.disableValidaRubro = true;
    const alertConfirm = await Utilerias.alertConfirm(`¿Deseas validar el rubro ${this.rubro.Nombre} ?`);

    if (alertConfirm.value) {
      const { Roles, IdEmpleado } = await MasterDB.getUsuarioSesion(new EstacionesTVADB());

      const body: ValidaRubroDTO = {
        rubro: {
          IdRubro: idRubro,
          IdRevision: this.global.idRevision
        },
        historial: {
          IdRubro: idRubro,
          IdRevision: this.global.idRevision,
          IdRolValido: Roles[0].IdRol,
          IdEmpleadoValido: IdEmpleado,
          FlagValidadoRechazado: 1
        }
      }

      this.rubroService.postValidaRubro(body)
        .subscribe(resp => {
          if (resp.Result.Exito) {
            const tranRubro = resp.Result.Data as RubroTranRubro

            this.rubro.IdNivelValidacion = tranRubro.IdNivelValidacion;
            this.rubro.IdRolValidacion = tranRubro.IdRolValidacion;
            this.rubro.RolValidacion = tranRubro.RolValidacion;
            this.rubro.IdEstatus = tranRubro.IdEstatus;
            this.rubro.Estatus = this.global.CatEstatusRubro.find(x => x.IdEstatusRubro == this.rubro.IdEstatus);            

            if (tranRubro.IdEtapaRevision == 3) {
              this.parent.revision.IdEtapa = tranRubro.IdEtapaRevision;
              Utilerias.alertClient('Revision validada.', 'Todos los rubros de la revisión ya se encuentran validados. \n En la parte superiror se puede generar el informe preliminar.', 2);
            }
          }
          this.disableValidaRubro = false;
        })
    }
  }

  clickRechazarRubro(idRubro) {
    localStorage['IdRubroValidar'] = idRubro;
    $('#modalMotivo').modal('show');
  }

  clickObservaciones(rubro) {
    this.parent.txtObservaciones = rubro.ObservacionesInformeFinal ?? '';
    this.parent.IdRubroObservacion = rubro.IdRubro;
    $('#modalObservaciones').modal('show');
  }

  clickAcciones(rubro) {
    debugger;
    this.parent.configCrudAcciones.crudHttp.paramGet = {
      IdRubro: rubro.IdRubro + '|' + rubro.IdRevision
    };
    this.parent.configCrudAcciones.crudHttp.paramPost = {
      IdRubro: rubro.IdRubro,
      IdRevision: this.global.idRevision
    }
    this.parent.crudComponent.bind();
    $('#modalAcciones').modal('show');
  }

  clickShowMotivo(idRubro) {
    let param = {
      idRubro: idRubro,
      idRevision: this.global.idRevision
    };
    Utilerias.httpRequest(this.http, 'GetTranRubroMotivoRechazos', 'post', param)
      .then(res => {
        this.parent.listRechazos = res;
      });
    Utilerias.showLoader(false);
    $('#modalListMotivo').modal('show');
  }

  historial(idRubro) {
    let param = {
      idRubro: idRubro,
      idRevision: this.global.idRevision
    };
    Utilerias.httpRequest(this.http, 'GetHistorialValidacionRubro', 'post', param)
      .then(res => {
        this.parent.listHistorico = res;
      });
    Utilerias.showLoader(false);
    $('#modalHistorial').modal('show');
  }
}
